import Vue from 'vue';
import Vuex from 'vuex';
import { getLoginInfo } from '@/api/user'
import { t } from '@/utils/i18nHelper'
import { setSessionStorage, getSessionStorage, removeSessionStorage } from '@/utils/util'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: getSessionStorage('token') || '',
    code: getSessionStorage('code') || '',
    corpId: getSessionStorage('corpId') || '',
    userInfo: getSessionStorage('userInfo') || {}
  },
  getters: {
    isLoggedIn: state => !!state.token,
    token: state => state.token,
    code: state => state.code,
    corpId: state => state.corpId,
    userInfo: state => state.userInfo
  },
  mutations: {
    SET_VALUE_BY_KEY(state, { key, value }) {
      state[key] = value;
      setSessionStorage(key, value);
    },
    SET_TOKEN(state, token) {
      state.token = token;
      setSessionStorage('token', token);
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo;
      setSessionStorage('userInfo', userInfo);
    },
    CLEAR_USER(state) {
      state.token = '';
      state.userInfo = {};
      removeSessionStorage('token');
      removeSessionStorage('userInfo');
    }
  },
  actions: {
    // 登录
    login({ commit }, userInfo) {
      return new Promise(resolve => {
        // 这里通常会有实际的API请求
        // 演示用，直接设置假数据
        const token = 'demo_token_123456';
        const user = {
          id: 1,
          username: userInfo.username,
          name: '管理员',
          avatar: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'
        };

        commit('SET_TOKEN', token);
        commit('SET_USER_INFO', user);
        resolve(user);
      });
    },
    // 登出
    logout({ commit }) {
      return new Promise(resolve => {
        commit('CLEAR_USER');
        resolve();
      });
    },
    // 处理外部Token登录
    async handleExternalLogin({ commit }, token) {
      try {
        // 1. 保存token
        commit('SET_TOKEN', token)
        
        // 2. 获取用户信息
        let userInfo = await getLoginInfo()
        userInfo = userInfo.data;
        // 3. 保存用户信息
        commit('SET_USER_INFO', userInfo)
        
        return {
          success: true,
          message: t('authRedirect.loginSuccess')
        }
      } catch (error) {
        // 失败时清除token和用户信息
        commit('CLEAR_USER')
        return {
          success: false,
          message: error.message || t('authRedirect.getUserInfoFailed')
        }
      }
    }
  }
});
